import { api } from '../../services/api'
import { showSuccess, showError } from '../misc/misc.actions'
import { getBalances, getTransactions } from '../households/households.actions'

export const createCredits = (facilityId, clientId, payload) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_CREDITS' })
		return api
			.post(`/facilities/${facilityId}/clients/${clientId}/credits/daycare`, payload)
			.then((response) => {
				const { data } = response
				const { credit = 0, giftcard_balance = 0 } = data.household || {}

				dispatch(showSuccess('Credits added successfully.'))
				dispatch(getBalances(clientId))
				dispatch(getTransactions(clientId))
				dispatch({ type: 'UPDATE_CREDITS_SUCCESS', payload: data })
				dispatch({
					type: 'UPDATE_SELECTED_HOUSEHOLD',
					payload: { household_id: data._id, updates: { credit, giftcard_balance } }
				})
			})
			.catch((e) => {
				dispatch(showError('An error occured while adding credits.'))
				dispatch({ type: 'UPDATE_CREDITS_FAIL' })
			})
	}
}

export const deleteCredits = (facilityId, clientId, payload) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_CREDITS' })
		return api
			.post(`/facilities/${facilityId}/clients/${clientId}/credits/daycare/remove`, payload)
			.then((response) => {
				dispatch(showSuccess('Credits removed successfully.'))
				dispatch({ type: 'DELETE_CREDITS_SUCCESS', payload: response.data })
			})
			.catch(() => {
				dispatch(showError('An error occured while removing credits.'))
				dispatch({ type: 'UPDATE_CREDITS_FAIL' })
			})
	}
}
